import { connect } from 'react-redux';
import { compose } from 'recompose';
import CarrierRevenueCell from './component';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['net_full_cost', 'currency', 'shipper_orders'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { net_full_cost: cost, currency } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      fields
    );

    return {
      cost: typeof cost === 'string' ? Number(cost) : cost,
      currency,
    };
  })
);

export default enhance(CarrierRevenueCell);
